import Swiper from 'swiper';
import { A11y, Autoplay, Navigation, FreeMode, Pagination } from 'swiper/modules';
import {
  updateSlideAccessibility,
  setSwiperButtonAriaLabels,
  updateNavigationAccessibility,
} from '../components/common/carousel';

const peopleSlidersList = document.querySelectorAll('.swiper-people-slider');

document.addEventListener('DOMContentLoaded', () => {
  mountSlidersByElementsList(peopleSlidersList);
  initTimelineSlider();
});

const mountSlidersByElementsList = nodeList => {
  nodeList.forEach(element => {
    let isAutoPlay = element.classList.contains('autoplay');
    let isLoop = element.classList.contains('loop');

    const swiper = new Swiper(element, {
      modules: [Navigation, A11y, Autoplay],
      slidesPerView: 1,
      spaceBetween: 8,
      loop: isLoop,
      autoplay: isAutoPlay,
      navigation: {
        nextEl: '.btn-carousel-next',
        prevEl: '.btn-carousel-prev',
      },
      breakpoints: {
        700: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    });

    const onTab = event => {
      if (event.key === 'Tab') {
        if (swiper.params.loop) {
          swiper.params.loop = false;
          swiper.loopDestroy();
        }
        element.removeEventListener('keydown', onTab);
      }
    };
    element.addEventListener('keydown', onTab);
  });
};

const initTimelineSlider = () => {
  const timeline = document.querySelector('.swiper-timeline');
  if (!timeline) return;

  new Swiper(timeline, {
    modules: [Navigation, A11y, FreeMode, Pagination],
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 16,
    width: 212,
    pagination: {
      enabled: true,
      el: '.swiper-pagination-timeline',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.btn-timeline-next',
      prevEl: '.btn-timeline-prev',
    },
    breakpoints: {
      400: { slidesPerView: 'auto', centeredSlides: false, width: null },
      700: { spaceBetween: 32, centeredSlides: false, slidesPerView: 'auto' },
    },
    on: {
      init() {
        checkVisibility(this), updateSlideAccessibility(this);
        updateNavigationAccessibility(this);
        setSwiperButtonAriaLabels(this.el);
      },
      slideChange() {
        checkVisibility(this), updateSlideAccessibility(this);
        updateNavigationAccessibility(this);
      },
      resize() {
        updateNavigationAccessibility(this);
      },
    },
  });

  function checkVisibility() {
    const lastSlide = document.querySelector('.swiper-timeline .swiper-slide:last-child');
    if (!lastSlide) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          document.querySelector('.btn-timeline-next').classList.toggle('disabled', entry.isIntersecting);
        });
      },
      { threshold: 1 },
    );

    observer.observe(lastSlide);
  }
};
